window["__ris_global_vars__"] = {
	singleEndPoint:!0,
	baseResourceUrl:"/Web/",
	version:$CHANGESET$,
	loggerDefaults:{
		appender:"browserConsole",appenderLevel:"5",loggerLevel:"5"
	},
	apiServer:{
		host:"ris.mri-ct.com",port:"443",ssl:"true",base:"CSHRIS-CSHRIS/riswebserver/api"
	},
	authServer:{
		host:"ris.mri-ct.com",port:"443",ssl:"true",base:"CSHRIS-CSHRIS/authenticationserver/OAuth"
	},
	authServerApi:{
		host:"ris.mri-ct.com",port:"443",ssl:"true",base:"CSHRIS-CSHRIS/authenticationserver/api"
	},
	browser:{
		Chrome:null,Edge:79,Safari:11
	}
};
